/**
 * Constants safe for any consumer, browser included.
 *
 * Kept apart from app-config.ts on purpose. This package exports source rather
 * than a build, and zod constructs its schemas at module scope, so anything
 * re-exported alongside the config schema is unconditionally pulled into a
 * browser bundle that imports it — tree-shaking cannot drop a side-effecting
 * module graph. Reach this file through `@dws/shared/branding`; the barrel at
 * `@dws/shared` is for server and infrastructure code.
 *
 * Enforced by apps/web/src/bundle.test.ts.
 */
export const APP_NAME = 'Dance Works Store'
